import React, { useCallback, useEffect, useSyncExternalStore } from "react";
import classNames from "classnames";
import styles from "./tags-element.module.scss";
import FixTag from "../fix-tag";
import { AreaStore, useAreaStore } from "@/pages-react/category-page/sample5";
import { useProductArea } from "../product-area/context";

export interface TagsElementProps {
  store: AreaStore;
}

const TAG_TYPES = ["brands", "categories"] as const;

function getTagName(type: string) {
  switch (type) {
    case "brand":
      return "Brand";
    case "category":
      return "Category";
    default:
      return "Value";
  }
}

export const TagsElement = () => {
  const store = useProductArea();
  const handleRemove = (id: string) => {
    store.removeSelection('main', id);
  };

  const groups = TAG_TYPES.map((type) => {
    const group = store.groups['main'];
    const options = group.options[type] ?? [];
    const list = options
      .map((option) => ({
        key: option.key,
        name: option.name,
        selected: group.selections.has(option.key),
      }))
      .filter((item) => item.selected);

    return {
      type,
      list
    };
  });

  return (
    <div className={styles.tags}>
      {groups.map((group) => (
        <div className={styles.group} key={group.type}>
          {group.list.map((item) => (
            <FixTag key={item.key} id={item.key} name={getTagName(group.type)} value={item.name} onRemove={handleRemove} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TagsElement;
